<template lang="pug">
.introContainer
    .introImg(:style="{'background-image': 'url(' + intro[year].src + ')'}")
        .introMask
            .introText {{intro[year].text1}}
            h1.TitleU {{intro[year].name}}
            .introText(v-html="intro[year].text2")

</template>

<script>

export default {
    props: ['year'],
    data () {
        return {
            intro: {
                2026: {
                    name: "The Sixth Workshop on Multiple Input Modalities and Sensations for VR/AR Interactions (MIMSVAI 2026)",
                    src: 'https://mimsvai.github.io/static/imgs/banner.jpg',//image less than 5
                    text1: 'October 11th, 2026, in Shanghai, China',
                    text2: '<span>Workshop in conjunction with </span><a href="https://www.ubicomp.org/ubicomp-iswc-2026/" target="blank" style="color: #e89700;">UbiComp 2026↗︎</a>'
                },
                2025: {
                    name: "The Fifth Workshop on Multiple Input Modalities and Sensations for VR/AR Interactions (MIMSVAI 2025)",
                    src: 'https://mimsvai.github.io/static/imgs/banner.jpg',//image less than 5
                    text1: 'October 13th, 2025, in Espoo, Finland',
                    text2: '<span>Workshop in conjunction with </span><a href="https://www.ubicomp.org/ubicomp-iswc-2025/" target="blank" style="color: #e89700;">UbiComp 2025↗︎</a>'
                },
                2024: {
                    name: "The Fourth Workshop on Multiple Input Modalities and Sensations for VR/AR Interactions (MIMSVAI 2024)",
                    src: 'https://mimsvai.github.io/static/imgs/banner.jpg',//image less than 5
                    text1: 'October 6th, 2024, in Melbourne, Australia',
                    text2: '<span>Workshop in conjunction with </span><a href="https://www.ubicomp.org/ubicomp-iswc-2024/" target="blank" style="color: #e89700;">UbiComp 2024↗︎</a>'
                },
                2023: {
                    name: "The Third Workshop on Multiple Input Modalities and Sensations for VR/AR Interactions (MIMSVAI 2023)",
                    src: 'https://mimsvai.github.io/static/imgs/banner.jpg',//image less than 5
                    text1: 'October 9th, 2023, in Cancún, Mexico',
                    text2: '<span>Workshop in conjunction with </span><a href="https://www.ubicomp.org/ubicomp-iswc-2023/" target="blank" style="color: #e89700;">UbiComp 2023↗︎</a>'
                },
                2022: {
                    name: "The Second Workshop on Multiple Input Modalities and Sensations for VR/AR Interactions (MIMSVAI 2022)",
                    src: 'https://mimsvai.github.io/static/imgs/banner.jpg',//image less than 5
                    text1: 'September 11, 2022, organised virtually',
                    text2: '<span>Workshop in conjunction with </span><a href="https://www.ubicomp.org/ubicomp2022/" target="blank" style="color: #e89700;">UbiComp 2022↗︎</a>'
                },
                2021: {
                    name: "The First Workshop on Multiple Input Modalities and Sensations for VR/AR Interactions (MIMSVAI 2021)",
                    src: 'https://mimsvai.github.io/static/imgs/banner.jpg',//image less than 5
                    text1: 'September 26, 2021, organised virtually',
                    text2: '<span>Workshop in conjunction with </span><a href="https://www.ubicomp.org/ubicomp2021/" target="blank" style="color: #e89700;">UbiComp 2021↗︎</a>'
                }
            }
        }
    },
    methods: {

    }
}
</script>

<style lang="sass" scoped>
.introContainer
    max-width: 1080px
    margin: auto
.introImg
    max-width: 1280px
    margin: auto
    height: 720px
    border-radius: 8px
    position: relative
    // /*opacity: 0.7; optional will put a slide fade on the background images  */
    background-attachment: fixed
    background-position: right
    background-repeat: no-repeat
    background-color: #FFF
    background-size: cover
.introText
    font-size: 19px
.introMask
    position: inherit
    padding: 20px
    background-color: #ffffffba
    top: 400px
    z-index: 1

@media all and (max-width: 960px)
    .TitleU
        font-size: 25px
    .introMask
        top: 200px

</style>



// WEBPACK FOOTER //
// src/components/mainPage/Intro.vue